import React, {useEffect, useState} from "react";
import './BlogList.scss';

import Header from "../../components/Header";
import Button from "react-bootstrap/Button";
import Footer from "../../components/Footer";
import Alert from "react-bootstrap/Alert";

let img_top = require("../../assets/Blog.jpg");

function BlogList() {
    useEffect(() => {
        document.title = "Geoticket - Trucchi e consigli";
    }, []);
    const [list, setList] = useState([]);

    useEffect(() => {
        fetch(global.route.blogList, {
            method: "post",
            credentials: 'include',
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(response => {
                        setList(response.list);
                    });
                }
            });
    }, []);


    let getList = () => {
        if (list.length === 0) {
            return <Alert key={"warning"} variant={"warning"}>Nessun dato disponibile</Alert>;
        }
        let result = [];
        for (let item of list) {
            result.push(<div className={"col-md-4"}>
                <div className="card">
                    <img src={global.baseUrl + item.image} alt="Card image cap" className={"card-image"} onClick={() => {window.location.href = "/blog/"+item.sku}}/>
                    <div className="card-button">
                        <Button className={"btn-orange"} href={"/blog/"+item.sku}>Leggi di più</Button>
                    </div>
                    <div className="card-body">
                        {item.title}<br/>
                        <small className="text-muted">{item.date}</small>
                    </div>
                </div>
            </div>);
        }
        return <div className={"row"}>{result}</div>;
    }

    return (
        <div style={{backgroundColor: "#fafafa"}} className={"blog-list"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">Trucchi e consigli: scopri il nostro <b><span className={"orange"}>Blog</span></b></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container mt-4 mb-4"}>
                {getList()}
            </div>
            <Footer/>
        </div>
    );
}

export default BlogList;